import Title from "./Title";

export * from "./Title";

export default Title;
